export const blank = <path />;
